import HttpService from "./htttp.service";

class ClientsService {
  getClients = async (page, pageSize, sortColumn, sortColumnValue, searchValue) => {
    let fetchUrl = "clients";
    if (page && pageSize && sortColumn && sortColumnValue) {
      fetchUrl = `clients?page=${page}&per_page=${pageSize}&sort_column=${
        sortColumn
      }&sort_column_value=${sortColumnValue}&search_value=${encodeURIComponent(searchValue)}`;
    }
    return await HttpService.get(fetchUrl);
  };

  addClient = async (newClient) => {
    const fetchUrl = "clients";
    return await HttpService.post(fetchUrl, newClient);
  };

  updateClient = async (id, data) => {
    const fetchUrl = `clients/${id}`;
    return await HttpService.put(fetchUrl, data);
  };

  updateActiveClient = async (id, data) => {
    const fetchUrl = `clients/${id}`;
    return await HttpService.patch(fetchUrl, data);
  };

  showClient = async (id) => {
    const fetchUrl = `clients/${id}`;
    return await HttpService.get(fetchUrl);
  };

  deleteClient = async (id) => {
    const fetchUrl = `clients/${id}`;
    return await HttpService.delete(fetchUrl);
  };
}

export default new ClientsService();
